import type { ComponentType } from 'react';
import React from 'react';

import SuccessIcon from '@atlaskit/icon/core/check-mark';
import ErrorIcon from '@atlaskit/icon/core/cross-circle';
import StatusInformationIcon from '@atlaskit/icon/core/status-information';
import StatusSuccessIcon from '@atlaskit/icon/core/status-success';
import StatusWarningIcon from '@atlaskit/icon/core/status-warning';
import type { GlyphProps } from '@atlaskit/icon/types';
import type { NewIconProps } from '@atlaskit/icon/base-new';
import { token } from '@atlaskit/tokens';
import type { IconColor } from '@atlaskit/tokens/css-type-schema';

function colorizeIcon(
	Icon: ComponentType<GlyphProps> | ComponentType<NewIconProps>,
	color: IconColor,
	isBold: boolean,
	type: 'success-circle' | 'success' | 'error' | 'warning' | 'info' | 'custom',
) {
	return isBold ? (
		<Icon label="" color="currentColor" spacing="spacious" testId={`flag-${type}`} />
	) : (
		<Icon label="" color={color} spacing="spacious" testId={`flag-${type}`} />
	);
}

export const FlagIcon = ({
	type,
	isBold,
	customIcon,
}: {
	type?: 'success-circle' | 'success' | 'error' | 'warning' | 'info' | 'custom';
	isBold: boolean;
	customIcon?: JSX.Element;
}): React.JSX.Element => {
	switch (type) {
		case 'success-circle':
			return colorizeIcon(StatusSuccessIcon, token('color.icon.success'), isBold, type);
		case 'success':
			return colorizeIcon(SuccessIcon, token('color.icon.success'), isBold, type);
		case 'error':
			return colorizeIcon(ErrorIcon, token('color.icon.danger'), isBold, type);
		case 'warning':
			return colorizeIcon(StatusWarningIcon, token('color.icon.warning'), isBold, type);
		case 'custom':
			return (
				customIcon ??
				colorizeIcon(StatusInformationIcon, token('color.icon.information'), isBold, 'info')
			);
		case 'info':
		default:
			return colorizeIcon(StatusInformationIcon, token('color.icon.information'), isBold, 'info');
	}
};
